<template>
  <div>
      <el-input class="search-el" size="mini" v-model="query.name" placeholder="请输入助教姓名"></el-input>
      <el-button type="primary" size="mini" @click="getList()">
      查询
    </el-button>
<!--    <el-button type="primary" size="small" @click="toCreate()">
      添加
    </el-button>-->

    <el-row>
      <el-table
        v-loading="loading"
        :data="list"
        border
        size="mini"
        :stripe="true"
        style="width: 100%; margin: 20px 0"
      >
        <el-table-column
          prop="id"
          label="ID"
          align="center"
          min-width="8%"
        ></el-table-column>
        <el-table-column
          label="姓名"
          align="center"
          min-width="10%"
        >
        <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="toCreate(row.id)">
              <div>{{ row.real_name }}</div>
            </el-button>
        </template> 
        </el-table-column>
        <el-table-column label="头像" align="center" min-width="10%">
          <template slot-scope="{ row }">
            <img :src="row.avatar" style="width: 40px" alt="" />
          </template>
        </el-table-column>
        <el-table-column
          prop="desc"
          label="简介"
          align="left"
          min-width="30%"
        ></el-table-column>
        <el-table-column
            prop="score"
            label="积分"
            align="center"
            min-width="8%"
        ></el-table-column>



        <el-table-column
          label="排序"
          align="center"
          min-width="8%"
        >
        <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="updateAssistantSort(row.id,row.sort)">
              <div>{{ row.sort }}</div>
            </el-button>
        </template> 
        </el-table-column>

        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="{ row }">
              <el-button
              type="text"
              size="mini"
              @click="toTreadsList(row.id)"
            >
              <div>助教动态</div>
            </el-button>

          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <div class="block">
        <el-pagination
          background
          @current-change="getList"
          :current-page.sync="query.page"
          :page-size="query.limit"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
import { getAssistantList,  updateAssistantSort } from "@/api/assistant";

export default {
  data: function () {
    return {
      dialogVisible: false,
      list: [],
      loading: false,
      total: 0,
      query: {
        page: 1,
        limit: 20,
        name: ""
      },
    };
  },
  created: function () {
    this.getList();
  },
  methods: {
    toCreate(id) {
      this.$router.push({
        path: "/assistant/info",
        query: {
          id: id
        }
      });
    },

    toTreadsList(id) {
      this.$router.push({
        path: "/assistant/treadsList",
        query: {
          id: id
        }
      });
    },

    getList() {
      this.loading = true;
      getAssistantList(this.query).then((response) => {
        this.list = response.data.list;
        this.total = response.data.total;
        this.loading = false;
      });
    },

    updateAssistantSort(id) {
        this.$prompt('请输入排序', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          inputPattern: /[0-9]/,
          inputErrorMessage: '格式不正确'
        }).then(({ value }) => {
          updateAssistantSort({
            id: id,
            sort: value,
          }).then((response) => {
            if (response.status == 2000) {
              this.getList();
              this.$message({
                showClose: true,
                message: "设置成功",
                type: "success",
              });
            } else {
              this.$message({
                showClose: true,
                message: response.message,
                type: "error",
              });
            }
          });
        }).catch(() => {
               
        });
    },

  },
  mounted() {
    
  },  
};
</script>